<template>
    <div class="barra-titolo-azioni fissa-in-alto bg-white border-bottom py-2 mt-0">
        <div class="container-fluid">
            <div class="row d-flex justify-content-between flex-wrap align-items-center">
                <div class="col-sm-6 d-flex justify-content-start align-items-center">
                    <div class="navbar-nav pulsante-indietro">
                        <a
                            title="Indietro"
                            @click="goBack"
                        >
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />
                        </a>
                    </div>
                    <div class="titolo-status">
                        <h1
                            class="mb-0 text-dark"
                            v-show="!editingEventName"
                        >
                            <span class="titolo-gallery">{{
                                            gallery.title
                                        }}</span>
                            &nbsp;
                            <a
                                href=""
                                @click.prevent="editingEventName = true"
                            >
                                <font-awesome-icon :icon="['fas', 'pencil-alt']" />
                            </a>
                        </h1>
                        <b-input-group
                            class="modifica-titolo-evento mb-0"
                            v-show="editingEventName"
                        >
                            <b-form-input
                                class="px-2 py-1"
                                :value="gallery.title"
                                ref="eventNameInput"
                            ></b-form-input>
                            <b-input-group-append v-show="!savingEventName">
                                <b-button
                                    class="btn btn-primary rounded-right px-2 py-0"
                                    @click="setEventName()"
                                >
                                    {{$t("Salva")}}
                                </b-button>
                            </b-input-group-append>
                            <b-input-group-append v-show="savingEventName">
                                <b-button
                                    class="btn btn-primary rounded-right px-2 py-0"
                                    disabled
                                >
                                    {{$t("Salvataggio")}}
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <p class="mb-0">
                            <span v-bind:class="[gallery.status === 'ATTIVO' ? 'text-success small' : 'text-danger small']">{{
                                            gallery.status
                                        }}</span>
                        </p>
                    </div>
                </div>
                <div class="col-sm-6 mt-3 mt-sm-0">
                    <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                        <li
                            v-if="!hideBtnShare"
                            class="d-inline-block mr-2"
                        >
                            <b-dropdown toggle-class="pulsante-condividi-gallery btn btn-primary btn-rikorda1">
                                <template v-slot:button-content>
                                    {{ $t("Condividi") }}
                                </template>
                                <b-dropdown-item @click="onShareGallery">
                                    {{ $t("Tramite mail") }}
                                </b-dropdown-item>
                                <b-dropdown-item v-b-modal.copy-link-modal>
                                    {{ $t("Tramite link") }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </li>
                        <li
                            v-if="!hideBtnPreview"
                            class="d-inline-block mr-2"
                        >
                            <button
                                href="javascript:void(0)"
                                class="pulsante-anteprima-gallery btn btn-light border"
                                @click="goToGalleryPreview"
                            >
                                {{ $t("Anteprima") }}
                            </button>
                        </li>
                        <li
                            v-if="!hideBtnAgents"
                            class="d-inline-block"
                        >
                            <button
                                class="pulsante-assegna-collaboratore btn btn-primary btn-rikorda1"
                                v-b-modal.associate-event-agent-modal
                                v-if="Array.isArray(agents) && agents.length && !hasAssociatedAgent()"
                            >
                                {{$t("Assegna a collaboratore")}}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- popup associazione evento agente -->
        <b-modal
            id="associate-event-agent-modal"
            title="Assegna evento"
            ok-title="Assegna"
            cancel-title="Annulla"
            @ok="onAssociateAgentOk"
        >
            <b-form-select
                class="form-control"
                v-model="localSelectedAgent"
                :options="agents"
                value-field="fkUtente"
                text-field="email"
                required
            >
                <template #first>
                    <b-form-select-option value="">{{$t('Non assegnare')}}</b-form-select-option>
                </template>
            </b-form-select>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "BackendGalleryHeader",

    props: {
        eventId: { type: String, required: true, default: "" },
        gallery: { type: Object, required: true },
        agents: {
            type: Array,
            required: false,
            default: () => {
                return [];
            }
        },
        associatedAgent: {
            type: Object,
            required: false,
            default: () => {
                return {};
            }
        },
        selectedAgent: { type: String, required: false, default: "" },
        hideBtnShare: { type: Boolean, required: false, default: false },
        hideBtnPreview: { type: Boolean, required: false, default: false },
        hideBtnAgents: { type: Boolean, required: false, default: false }
    },

    data() {
        return {
            editingEventName: false,
            savingEventName: false,
            localSelectedAgent: null
        };
    },

    mounted() {
        this.localSelectedAgent = this.selectedAgent;
    },

    methods: {
        goBack() {
            this.$emit("back");
        },

        onShareGallery() {
            this.$router.push({
                name: "backend-gallery-share",
                params: { eventId: this.eventId }
            });
        },

        goToGalleryPreview() {
            this.$store
                .dispatch("BACKEND_SET_FRONTEND_TOKEN", {
                    eventId: this.eventId
                })
                .then((response) => {
                    if (response.token) {
                        var routerResolve = this.$router.resolve({
                            name: "gallery-dashboard",
                            params: { galleryUrl: this.gallery.url }
                        });
                        window.open(routerResolve.href, "_blank");
                    }
                });
        },

        onAssociateAgentOk() {
            this.$emit("associateAgent", this.localSelectedAgent);
            this.localSelectedAgent = "";
        },

        hasAssociatedAgent() {
            return (
                typeof this.associatedAgent === "object" &&
                this.associatedAgent !== null &&
                Object.prototype.hasOwnProperty.call(
                    this.associatedAgent,
                    "email"
                )
            );
        },

        setEventName() {
            let newName = this.$refs.eventNameInput.vModelValue.trim();
            if (newName.length > 0 && this.gallery.title !== newName) {
                this.savingEventName = true;
                let eventData = {
                    titolo: newName
                };
                this.$api
                    .backendSetEventSettings(this.eventId, eventData)
                    .then((response) => {
                        console.log("BACKEND_SET_EVENT_SETTINGS", response);
                        this.gallery.title = newName;
                        this.savingEventName = false;
                        this.editingEventName = false;
                    })
                    .catch((error) => {
                        console.error("BACKEND_SET_EVENT_SETTINGS", error);
                        this.savingEventName = false;
                    });
            } else {
                this.editingEventName = false;
            }
        }
    }
};
</script>

<style>
</style>
